import { Project } from 'src/store/state/projects';
import { ReduxState } from 'src/store/types';

export const projectSelector =
  (projectId: string) =>
  (state: ReduxState): Project | undefined =>
    state.projects.projectsById[projectId];
